var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthAfricaIc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.552734 0H12.1696V8.29773H0.552734V0Z",
    fill: "url(#paint0_linear_5545_84425)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.552734 0H12.1696V8.29773H0.552734V0Z",
    fill: "url(#paint1_linear_5545_84425)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.552734 1.10547L4.42501 4.14797L0.552734 7.19047V1.10547Z",
    fill: "url(#paint2_linear_5545_84425)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.24609L3.73398 4.1503L0 7.0545V1.24609Z",
    fill: "url(#paint3_linear_5545_84425)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53243 3.31909L1.66016 0H12.1706V3.31909H5.53243Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67065 2.76591L2.35156 0H12.1705V2.76591H5.67065Z",
    fill: "url(#paint4_linear_5545_84425)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66016 8.29956H12.1706V4.98047H5.53243L1.66016 8.29956Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35156 8.29716H12.1705V5.53125H5.67065L2.35156 8.29716Z",
    fill: "url(#paint5_linear_5545_84425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5545_84425",
    x1: 122.529,
    y1: 0,
    x2: 122.529,
    y2: 124.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5545_84425",
    x1: 122.529,
    y1: 0,
    x2: 122.529,
    y2: 124.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007A4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5545_84425",
    x1: 41.2116,
    y1: 1.10547,
    x2: 41.2116,
    y2: 92.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB612"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5545_84425",
    x1: 39.2068,
    y1: 1.24609,
    x2: 39.2068,
    y2: 88.3722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5545_84425",
    x1: 105.451,
    y1: 0,
    x2: 105.451,
    y2: 41.4886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3931"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5545_84425",
    x1: 105.451,
    y1: 5.53125,
    x2: 105.451,
    y2: 47.0199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#072CB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042396"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfricaIc);
export default __webpack_public_path__ + "static/media/south-africa-ic.d596ced2d51c5de96d231bf602ad9726.svg";
export { ForwardRef as ReactComponent };